/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
    Grid,
    Popper,
    List,
    ListItem,
    ClickAwayListener,
} from '@material-ui/core';

import { useStyles } from './styles';

import countryCodeData from './countryCodeData';

function CountryCodeList ({
    open = false,
    anchorEl = null,
    onCloseList = () => {},
    onItemClick = () => {},
    selectedCodeIndex = 0,
    country = '',
}) {

    const [data] = useState(countryCodeData);

    const [_open, setOpen] = useState(open);
    const listRef = useRef();
    const [inputSize, setInputSize] = useState()
    const classes = useStyles({ inputSize });
  
    function determineSize () {
        const input = document.querySelector('#phone-input');
        if (input) {
            setInputSize({ width: input.offsetWidth, height: input.offsetHeight });
        } else {
            setTimeout(determineSize, 200);
        }
    }

    useEffect(() => {
        determineSize();
    }, []);

    useEffect(() => {
        setOpen(open);
        setTimeout(scrollToSelection, 500);
    }, [open]);

    function scrollToSelection () {
        const container = listRef.current;
        const itemEl = document.querySelector(`#countrycode-${country}`);
        if (container && itemEl) {
            const containerRect = container.getBoundingClientRect();
            const itemRect = itemEl.getBoundingClientRect();
            const offset = itemRect.top - containerRect.top + container.scrollTop;
            container.scrollTo({
                top: offset - containerRect.height / 2 + itemRect.height / 2,
                behavior: 'smooth',
            });
        }
    }

    /* this create scrollable elements */
    function renderList () {
        return (
            <Grid
                id='country-code'
                className={classes.listParent}
                ref={listRef}
                >
                <List className={classes.list}>
                    { renderItems() }
                </List>
            </Grid>
        )
    }

    function renderItems () {
        if (!data || data.length <= 0) {
            return (<React.Fragment></React.Fragment>);
        }
        return data.map((item, i) => {
            
            let selected = 'false';
            if( selectedCodeIndex === i) {
                selected = 'true';
            }

            return (
                <ListItem
                    key={`countrycode-${i}`}
                    id={`countrycode-${item.iso2}`}
                    onClick={() => {
                        if (typeof onItemClick === 'function') {
                            onItemClick({
                                data: item,
                                index: i,
                            });
                        }
                    }}
                    className={classNames([ classes.listItem ])}
                    data-selected={selected}
                    >

                    <span className={classNames([
                            classes.flags,
                            classes[`flag_${item.iso2}`],
                        ])}></span>
                    <span className={classes.listItemCode}> +{ item.code } </span>
                    <span className={classes.listItemText}> { item.name } </span>
                </ListItem>
            );
        });
    }

    return (<React.Fragment>
        <ClickAwayListener
            onClickAway={() => {
                if (typeof onCloseList === 'function') {
                    onCloseList();
                }
            }}
        >
            <Popper
               open={_open}
               anchorEl={anchorEl}
               placement={'bottom-start'}
               style={{ zIndex: 1301 }}
            >
                <Grid className={classes.listBase}>
                    { renderList () }
                </Grid>
            </Popper>
        </ClickAwayListener>
    </React.Fragment>);
}

CountryCodeList.propTypes = {
    open: PropTypes.bool,
    anchorEl: PropTypes.any,
    onCloseList: PropTypes.func,
    onItemClick: PropTypes.func,
    selectedCodeIndex: PropTypes.number,
    country: PropTypes.string,
};

export default CountryCodeList;